import ActivityContextProvider from "PFApp/activities/show/activity_context_provider";
import ButtonLink from "PFComponents/button/button_link";
import WorkflowIcon from "PFIcons/workflow.svg";
import React from "react";
import { useTranslation } from "react-i18next";

import { useBookingActivityContext } from "../../../providers/booking_activity_context_provider";
import css from "./shortlist_detail.modules.scss";
import { ShortlistItems } from "./shortlist_items";

type ShortlistDetailProps = {
  showList?: boolean;
};

export const ShortlistDetail = ({ showList }: ShortlistDetailProps): JSX.Element => {
  const { id } = useBookingActivityContext();

  const { t } = useTranslation("bookingModule");
  return (
    <ActivityContextProvider id={id ?? ""} onActivityUpdate={() => {}}>
      <div className={css.shortListRoot}>
        <div className={css.header}>
          <div>{t("details.shortlisted")}</div>
          <ButtonLink
            href={`/activities/${id}/shortlist`}
            kind="tertiary"
            rootClassName={css.shortlistButton}
          >
            <WorkflowIcon height={24} width={24} />
            {t("details.viewInWorkflowShortlist")}
          </ButtonLink>
        </div>
        {showList && <ShortlistItems />}
      </div>
    </ActivityContextProvider>
  );
};
